import apiConfig from '../../../../../config/api'
import { apiRequestorHelper } from '../../../../../helpers'

export default {
	saveDS: (formId, datasource) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/formManager/saveDatasource/'+formId,
			method: 'post',
			body: datasource
		})
	},
	deleteDataSource: (id) => {
		return apiRequestorHelper({
			url: apiConfig.url + '/formManager/deleteDataSource',
			method: 'post',
			body: {id}
		})
	}
}
